import { Chip } from "@mui/material";
import React, { ReactElement } from "react";

interface IStatusChipProps {
  label: string;
  badgeColor: string;
  color: string;
  icon: ReactElement;
}

const StatusChip = ({ label, badgeColor, color, icon }: IStatusChipProps) => {
  return (
    <Chip
      icon={icon}
      label={label}
      sx={{
        backgroundColor: badgeColor,
        color: color,
        fontSize: "12px",
        lineHeight: "12px",
        height: "20px",
        padding: "0 8px",
        borderRadius: "8px",
        fontWeight: 600,
      }}
    />
  );
};

export default StatusChip;
